import React from "react";
import { Link } from "react-router-dom";
import "./css/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">

        <div className="footer-right">
          <a
            href="https://x.com/theofficialrpl"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Twitter"
            className="social-link"
          >
            X
          </a>
          <a
            href="https://www.tiktok.com/@official.ripple"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
            className="social-link"
          >
            TikTok
          </a>
        </div>

{/* 📞 Phone Number Block */}
<div className="footer-phone">
  <p>1-(888)-20-BITCOIN</p>
</div>

        <div className="footer-left">
          <p>© {new Date().getFullYear()} Vyral Media Group. All rights reserved.</p>
        </div>

        <div className="footer-center">
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          <Link to="/terms" className="footer-link">Terms of Service</Link>
          <Link to="/overview" className="footer-link">Overview</Link>
        </div>

      </div>
    </footer>
  );
};

export default Footer;